import { Component, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';

import { Log } from '../../../utils/index';
import { TrackerStatus, BreadcrumbItem } from '../../../entities/index';
import { TrackerStatusService } from '../../../services/trackerstatus.service';
import { SimpleCrudComponent } from '../simple-crud.component';

declare var jQuery: any;

@Component({
  selector: 'app-trackerstatus-list',
  templateUrl: './trackerstatus-list.html',
})
export class TrackerStatusListComponent extends SimpleCrudComponent implements OnInit {

  pageTitle = 'TrackerStatus List';
  breadcrumbs: BreadcrumbItem[] = [
    new BreadcrumbItem('TrackerStatus List', 'battery-full')
  ];

  constructor(protected trackerStatusService: TrackerStatusService, protected notification: NotificationsService) {
    super(trackerStatusService, TrackerStatus, notification);
  }

  @Log()
  ngOnInit() {
    this.getAll();
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/components/pages/trackerstatus/trackerstatus-list.component.ts